
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import functionUncurryThis from './function-uncurry-this.js';
import isCallable$1 from './is-callable.js';
import './shared-store.js';
import { s as sharedStore } from '../../../_virtual/shared-store.js';

var uncurryThis = functionUncurryThis;
var isCallable = isCallable$1;
var store = sharedStore.exports;

var functionToString = uncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString(it);
  };
}

var inspectSource = store.inspectSource;

export { inspectSource as default };
//# sourceMappingURL=inspect-source.js.map
